import { supabaseClient } from "supabase";
import { Database } from "types/supabase";

export const queryOrganizerVenues = async (
  organizerId: number | undefined
): Promise<Database["public"]["Tables"]["venues"]["Row"][]> => {
  if (!organizerId) return [];

  // First get the venue IDs associated with this organizer
  const { data: venueIds, error: venueIdsError } = await supabaseClient
    .from("organizers_venues")
    .select("venue_id")
    .eq("organizer_id", organizerId);

  if (venueIdsError) {
    console.error("Error fetching organizer venue IDs:", venueIdsError);
    throw venueIdsError;
  }

  if (!venueIds || venueIds.length === 0) {
    return [];
  }

  // Now get the actual venues
  const { data: venues, error: venuesError } = await supabaseClient
    .from("venues")
    .select("*")
    .in(
      "id",
      venueIds.map((record) => record.venue_id)
    );

  if (venuesError) {
    console.error("Error fetching venues:", venuesError);
    throw venuesError;
  }

  return venues || [];
};
